module.exports = __webpack_public_path__ + "1_0_65/img/recur.8e0d337e.svg";